var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApplications(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.001,2.667L24.001,2.667A2.667,2.667 0,0 1,26.667 5.333L26.667,26.667A2.667,2.667 0,0 1,24.001 29.334L8.001,29.334A2.667,2.667 0,0 1,5.334 26.667L5.334,5.333A2.667,2.667 0,0 1,8.001 2.667z",
    fill: "#909BF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.001,17.333H20.001",
    stroke: "#ffffff",
    strokeWidth: 2.66667,
    fill: "none",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.001,9.333H14.668",
    stroke: "#ffffff",
    strokeWidth: 2.66667,
    fill: "none",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.001,22.667H20.001",
    stroke: "#ffffff",
    strokeWidth: 2.66667,
    fill: "none",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.334,8L20.667,8A0.667,0.667 0,0 1,21.334 8.667L21.334,10A0.667,0.667 0,0 1,20.667 10.667L19.334,10.667A0.667,0.667 0,0 1,18.667 10L18.667,8.667A0.667,0.667 0,0 1,19.334 8z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplications);
export default __webpack_public_path__ + "static/media/applications.61813a1bdaa56d6c0ce71700a91a862c.svg";
export { ForwardRef as ReactComponent };